<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="!modoEdicao">
        <!-- Tabela -->
        <div v-if="lsDados.length > 0">
            <div class="table-wrapper row-space"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                    <th>Status</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                    <td class="col-width-char30">{{ obj.nmstatus }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>

        <div class="row-end">
            <button class="btn-small" @click="novoCadastro()">Incluir</button>
            <button class="btn-small" @click="closeForm()">Fechar</button>
        </div>
    </div>

    <div v-if="modoEdicao">
        <!-- CABEÇALHO -->
        <div v-if="showOsEdit" class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdos) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Ordem de Serviço (Nome / Identificação)</label>
                    <input type="text" v-model="objEdicao.nmos" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data Abertura</label>
                    <input type="date" v-model="objEdicao.dtabertura" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.nmstatus || '-' }}</div>
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <EquipamentoFrame :initId="objEdicao.idequipamento" v-model:objSelecionado="equipamentoSelecionado" />
                </div>

                <div class="form-item">
                    <FornecedorFrame :initId="objEdicao.idfornecedor" v-model:objSelecionado="fornecedorSelecionado" />
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="objEdicao.obs" maxlength="1000" rows="4" style="resize:none;" />
                </div>
            </div>

            <div class="row-end">
                <button class="btn-confirm" @click="salvarCabecalho">Salvar</button>
                <button class="btn-cancel" @click="cancelEdicao">Cancelar</button>
            </div>
        </div>


        <!-- CABEÇALHO VIEW -->
        <div v-if="!showOsEdit" class="form-edit-page row-space">
            <div class="row">
                <div class="form-item-char10">
                    <label class="label-caption">OS</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(osView.cdos) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Abertura</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(osView.dtabertura) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Descrição</label>
                    <div class="field-label">{{ osView.nmos }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Equipamento</label>
                    <div class="field-label">{{ osView.nmequipamento }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Situação</label>
                    <div class="field-label">{{ osView.nmstatus }}</div>
                </div>
            </div>
        </div>


        <!-- ITENS (serviços / produtos) -->
        <div v-if="showItemEdit" class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <ManutServicoFrame :refreshKey="servicoFrameRefresh" v-model:objSelecionado="servicoSelecionado" />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Qtd</label>
                    <input type="text" class="input-right" v-model="edQtd" v-decimal maxlength="15" />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Vl. Unit.</label>
                    <input type="text" class="input-right" v-model="edVlUnitario" v-decimal maxlength="15" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Obs Ítem</label>
                    <input type="text" v-model="edObsItem" maxlength="100" v-uppercase />
                </div>
            </div>

            <div class="row-end">
                <button class="btn-confirm" @click="salvarItem">{{ (idItemEdicao>0) ? 'Atualizar' : 'Adicionar' }}</button>
                <button class="btn-confirm" @click="abrirModalEncerrar">Encerrar Digitação</button>
                <button @click="cancelEdicao">Voltar</button>
                <button v-if="idItemEdicao>0" @click="limparItem">Limpar</button>
            </div>
        </div>


        <div v-if="showItemEdit && lsItens.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Serviço</th>
                    <th>Qtd</th>
                    <th>Vl Unit.</th>
                    <th>Vl Líq.</th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsItens" :key="obj.id" @click="editarItem(obj)"
                        :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td>{{ obj.nmservico }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.qtdd) }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.vlunitario) }}</td>
                        <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.vlliquido) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import ManutServicoFrame from '@/components/frames/ManutServicoFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null)
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const equipamentoSelecionado = ref(null);
const fornecedorSelecionado = ref(null);
const osView = reactive({});
const showItemEdit = ref(false);
const showOsEdit = ref(true);


// Itens
const lsItens = ref([]);
const servicoSelecionado = ref({});
const servicoFrameRefresh = ref(0);
const edQtd = ref(null);
const edVlUnitario = ref(null);
const edObsItem = ref(null);
const idItemEdicao = ref(0);


// const lsStatus = ref([
//     // TODO: se tiver tabela/endpoint de status, substitui aqui.
//     { cdstatus: 1, nmstatus: 'ABERTA' },
//     { cdstatus: 2, nmstatus: 'ORÇAMENTO' },
//     { cdstatus: 3, nmstatus: 'APROVAÇÃO' },
//     { cdstatus: 4, nmstatus: 'EXECUÇÃO' },
//     { cdstatus: 5, nmstatus: 'ENCERRADA' },
// ]);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function criarManutOs() {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamento: 0,
        idfornecedor: 0,
        cdos: 0,
        nmos: null,
        dtabertura: null,
        obs: null,
        idlogin: 0,
    });
}
const objEdicao = criarManutOs();


async function abrirModalEncerrar(){
    if (lsItens.value.length===0){
        msgAlerta.value='Necessário informar algum serviço para encerramento da solicitação';
        return;
    }
    const confirmado = await confirmModal.value.show({
        message: "Confirma encerramento dessa solicitação e envio para orçamento?",
        confirmText: 'Sim',
        cancelText: 'Não'
    })
    if (confirmado){salvarEncerraDigitacao()}
}


async function atualizarOsView(idOs) {
    try {
        msgAlerta.value = null;
        
        const respOs = await Api.genericPost('/dados/manut_os', {idmunicipio: globalStore.idmunicipio, id: idOs});
        if (respOs.length>0){
            Object.assign(osView, respOs[0]);
        }else{
            msgAlerta.value = 'Não foi possível ler os dados da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {
        isLoading.value = false;
    }
}


function cancelEdicao(){
    if (lsDados.value.length > 0){
        msgAlerta.value=null;
        modoEdicao.value = false;
        showOsEdit.value = false;
        showItemEdit.value = false;
    }else{
        closeForm();
    }
}

function closeForm() { emit('close'); }


async function editarCadastro(obj) {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.getCadastroById('manut_os', obj.id);
        Object.assign(objEdicao, req[0]);
        modoEdicao.value=true;
        showOsEdit.value=true;
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function editarItem(obj) {
    if (!showItemEdit.value) return;
    idItemEdicao.value = obj.id;
    servicoFrameRefresh.value = obj.cdservico || 0;
    // Para compatibilidade com Frame (ele retorna obj completo), guardo só quando seleciona.
    edQtd.value = Funcoes.formatDecimal(obj.qtdd);
    edVlUnitario.value = Funcoes.formatDecimal(obj.vlunitario);
    edObsItem.value = obj.obs;
}


function novoCadastro() {
    idEdicao.value = 0;
    modoEdicao.value = true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            intparam1: 1,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerItens() {
    const req = await Api.genericPost('/dados/manut_os_item', {
        idmunicipio: globalStore.idmunicipio,
        intparam1: osView.id,
        idlogin: globalStore.idlogin,
    });
    lsItens.value = req || [];
}


function limparItem() {
    idItemEdicao.value = 0;
    servicoSelecionado.value = null;
    servicoFrameRefresh.value = 0;
    edQtd.value = null;
    edVlUnitario.value = null;
    edObsItem.value = null;
}


async function salvarCabecalho() {
    try {
        msgAlerta.value = salvarCabecalhoValidacao();
        if (msgAlerta.value) return;

        // map frames -> ids
        objEdicao.idequipamento = equipamentoSelecionado.value.id;
        objEdicao.idfornecedor = fornecedorSelecionado.value?.id || 0;
        objEdicao.idmunicipio = globalStore.idmunicipio;
        objEdicao.idlogin = globalStore.idlogin;

        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os', objEdicao);

        if (resp.bolok === 1) {
            await atualizarOsView(resp.id);
            await lerItens()
            showOsEdit.value = false;
            showItemEdit.value = true;
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}
function salvarCabecalhoValidacao(){
    let r = Validar.id(equipamentoSelecionado.value, 'Informe o Equipamento');
    if (!r.ok) return r.msg;
    r = Validar.texto(objEdicao.nmos, 'Informe a Descrição');
    if (!r.ok) return r.msg;
    r = Validar.data(objEdicao.dtabertura, -365, 'Data de Abertura');
    if (!r.ok) return r.msg;
    return null;
}


async function salvarEncerraDigitacao(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const payload = {
            id: osView.id,
            solicitacao_idlogin: globalStore.idlogin,
            idlogin: globalStore.idlogin};
        const resp = await Api.genericPut('/cad/manut_os', payload);

        if (resp.bolok === 1) {
            closeForm();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível encerrar digitação da OS';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function salvarItem() {
    try {
        msgAlerta.value = salvarItemValidacoes();
        if (msgAlerta.value) return;
        
        const qtd = Funcoes.decimalFromString(edQtd.value);
        const vlunit = Funcoes.decimalFromString(edVlUnitario.value);
        const vlliq = qtd * vlunit;

        const payload = {
            id: idItemEdicao.value || 0,
            idos: osView.id,
            idproduto: 0,
            idservico: servicoSelecionado.value.id,
            qtdd: qtd,
            vlunitario: vlunit,
            vlliquido: vlliq,
            ckexecutado: 'N',
            obs: edObsItem.value,
            idlogin: globalStore.idlogin}

        isLoading.value = true;
        const resp = await Api.genericPut('/cad/manut_os_item', payload);
        if (resp?.bolok === 1) {
            limparItem();
            await lerItens();
        } else {
            msgAlerta.value = resp?.erro || 'Não foi possível salvar o item.';
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


function salvarItemValidacoes(){
    let r = Validar.id(servicoSelecionado.value, 'Informe o Serviço');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(edQtd.value, "Informe a Quantidade");
    if (!r.ok) return r.msg;
    return null;
}


async function startPage(){
    await lerDados();
    if (lsDados.value.length === 0){modoEdicao.value = true;}
}

onMounted(startPage);
</script>
